import { MarkExtension } from '../../../core/index.js';
import 'prosemirror-state';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import 'prosemirror-model';

var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
/**
 * 判断选区中是否存在可以应用markType的节点
 * @param doc doc文档
 * @param ranges 选区
 * @param type markType类型
 */ var isExistAllowsMarkType = function(doc, ranges, type) {
    var _loop = function(i) {
        var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
        var can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, function(node) {
            if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
            return !can;
        });
        if (can) return {
            v: true
        };
    };
    for(var i = 0; i < ranges.length; i++){
        var _ret = _loop(i);
        if (_typeof(_ret) === "object") return _ret.v;
    }
    return false;
};
/**
 * 添加新的mark类型
 * @param type mark类型
 * @param attrs mark属性
 * @param enhance
 */ var addMarkType = function(type, attrs, enhance) {
    return function(state, dispatch) {
        var _state_selection = state.selection, empty = _state_selection.empty, $cursor = _state_selection.$cursor, ranges = _state_selection.ranges;
        if (empty && !$cursor || !isExistAllowsMarkType(state.doc, ranges, type)) {
            return false;
        }
        // 是否为空光标
        if ($cursor) {
            // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
            var tr = state.tr;
            tr.addStoredMark(type.create(attrs));
            if (enhance) {
                tr = enhance(tr);
            }
            dispatch(tr);
        } else {
            var has = false;
            var tr1 = state.tr;
            for(var i = 0; !has && i < ranges.length; i++){
                var _ranges_i = ranges[i], $from = _ranges_i.$from, $to = _ranges_i.$to;
                has = state.doc.rangeHasMark($from.pos, $to.pos, type);
            }
            for(var i1 = 0; i1 < ranges.length; i1++){
                var _ranges_i1 = ranges[i1], $from1 = _ranges_i1.$from, $to1 = _ranges_i1.$to;
                // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
                if (has) tr1.removeMark($from1.pos, $to1.pos, type);
                tr1.addMark($from1.pos, $to1.pos, type.create(attrs));
            }
            dispatch(tr1);
        }
        return true;
    };
};
/*
 * 是否允许当前选区设置字体大小
 * @param state 当前编辑器的 EditState
 * @returns {boolean} 允许设置返回 true，否则返回 false
 */ function canSetFontSize(state) {
    var selection = state.selection, tr = state.tr, schema = state.schema;
    var _schema_nodes = schema.nodes, paragraph = _schema_nodes.paragraph, table = _schema_nodes.table, table_cell = _schema_nodes.table_cell, table_header = _schema_nodes.table_header, table_row = _schema_nodes.table_row, collapse = _schema_nodes.collapse, collapse_content = _schema_nodes.collapse_content, text = _schema_nodes.text, hard_break = _schema_nodes.hard_break;
    var bool = true;
    // 处于 CellSelection 时可能有多个 range
    selection.ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        tr.doc.nodesBetween(from, to, function(node) {
            if (node.type !== paragraph && node.type !== table && node.type !== table_cell && node.type !== table_header && node.type !== table_row && node.type !== collapse && node.type !== collapse_content && node.type !== hard_break && node.type !== text) {
                bool = false;
            }
        });
    });
    return bool;
}

var findFontSizeEmpty = function(state, defaultSize) {
    var _selection_$cursor;
    var schema = state.schema, selection = state.selection, tr = state.tr;
    var font = schema.marks.font;
    // 选区为空的情况
    var storedMarks = tr.storedMarks || state.storedMarks || ((_selection_$cursor = selection.$cursor) === null || _selection_$cursor === void 0 ? void 0 : _selection_$cursor.marks()) || [];
    var sm = storedMarks.find(function(m) {
        return m.type === font;
    });
    return sm ? sm.attrs.dataSize : defaultSize;
};
var findFontSizeRange = function(state, defaultSize) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var text = schema.nodes.text;
    var font = schema.marks.font;
    var ranges = selection.ranges;
    var lastFontSize = null;
    var retFlag = false;
    ranges.forEach(function(range) {
        var from = range.$from.pos;
        var to = range.$to.pos;
        // 如果选中的文本包含多个字号格式，则留空展示
        doc.nodesBetween(from, to, function(node, pos, parent, index) {
            if (retFlag) return;
            if (node.type !== text) return;
            var findMark = node.marks.find(function(mark) {
                return mark.type === font;
            });
            if (!findMark) {
                if (lastFontSize && lastFontSize !== defaultSize) {
                    lastFontSize = null;
                    retFlag = true;
                    return;
                }
                lastFontSize = defaultSize;
                return;
            }
            var fontSize = findMark.attrs.dataSize || defaultSize;
            if (index === 0) {
                lastFontSize = fontSize;
                return;
            }
            if (lastFontSize && lastFontSize !== fontSize) {
                lastFontSize = null;
                retFlag = true;
                return;
            }
            lastFontSize = fontSize;
        });
    });
    return lastFontSize;
};
// 获取菜单栏字号下拉列表激活态真实字号
var findActiveFontSize = function(state, defaultSize) {
    var selection = state.selection;
    var empty = selection.empty;
    // 选区为空的情况
    if (empty) return findFontSizeEmpty(state, defaultSize);
    // 选区为范围的情况
    return findFontSizeRange(state, defaultSize);
};
/**
 * 获取当前选区设置的字体
 */ var getFontSize = function() {
    var defaultSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
    return function(state) {
        return findActiveFontSize(state, defaultSize);
    };
};

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var FontExtension = /*#__PURE__*/ function(MarkExtension) {
    _inherits(FontExtension, MarkExtension);
    var _super = _createSuper(FontExtension);
    function FontExtension() {
        _classCallCheck(this, FontExtension);
        return _super.apply(this, arguments);
    }
    var _proto = FontExtension.prototype;
    _proto.commands = function commands(param) {
        var type = param.type;
        return {
            getSize: function() {
                return getFontSize();
            },
            setSize: function(font) {
                return addMarkType(type, {
                    dataSize: font
                });
            },
            isDisabled: function() {
                return function(state) {
                    return !canSetFontSize(state);
                };
            }
        };
    };
    _createClass(FontExtension, [
        {
            key: "name",
            get: function get() {
                return "font";
            }
        }
    ]);
    return FontExtension;
}(MarkExtension);

export { FontExtension };
//# sourceMappingURL=index.js.map
